import { render, staticRenderFns } from "./case-swiper.vue?vue&type=template&id=443397b4&scoped=true&"
import script from "./case-swiper.vue?vue&type=script&lang=js&"
export * from "./case-swiper.vue?vue&type=script&lang=js&"
import style0 from "./case-swiper.vue?vue&type=style&index=0&id=443397b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443397b4",
  null
  
)

export default component.exports